import React, { useRef, useState } from 'react'
import emailjs from 'emailjs-com'
import './contact.css'
import CV from '../../Assets/CV/LuisMiguelBarthaburu.pdf'

function Contact() {
  const formRef = useRef()
  const [done, setDone]=useState(false)


  const handleSubmit=(e)=>{
    e.preventDefault()
    emailjs.sendForm('service_8tdaifk','template_49fw0gw', formRef.current,'vJbZavf4-K6WsutXR')
    setDone(true)
    const formulario =document.getElementById('formulario')
    formulario.reset()
  }


  return (
    <section className='contact' id='contact'>
      <div className='clippath-form'></div>
      <h2 className='contact-title'>Contáctame</h2>
      <div className='form-container'>
        <form className='contacto-formulario' ref={formRef} onSubmit={handleSubmit} id='formulario'>
          <input type="text" required placeholder='Nombre'className='contacto-input' name='user_name'/>
          <input type="email" required placeholder='Email' className='contacto-input' name='user_email'/>
          <input type="text" required placeholder="Asunto" className='contacto-input' name='user_subject'/>
          <textarea id="mensaje" cols="20" rows="5" required placeholder='Mensaje'className='contacto-input' name='message'></textarea>
          <div className='buton-contianer'>
            {
              done?
              <p className='sent-msg' onClick={()=>setDone(false)}>Mensaje enviado con exito!</p>
              :
              <button className='form-btn'>Enviar Mensaje</button>
            }
            <a href={CV} download="LuisMiguelBarthaburu-CV.pdf" className='form-cv'>Descargar CV</a>
          </div>
        </form>
      </div>
    </section>
  )
}

export default Contact